<template>
  <span class="badge badge-match">Match mode</span>
</template>

<script>
export default {
  name: "MatchMode"
}
</script>

<style scoped>

</style>